import { serviceMaker } from "..";
import { IActiveInactive, IPagination } from "../../data/AppInterface";
import { TBitValue } from "../../data/AppType";
import { API_ENDPOINTS } from "../../utils/ApiEndPoint";

export interface IHelpCategoryPayload {
  id?: string;
  category_title: string;
  category_description: string;
  display_sequence?: number;
  is_active: string;
}
export interface IHelpTopicFormPayload {
  id?: string;
  topic_title: string;
  topic_description: string;
  help_category_Head?: number;
  display_sequence?: number;
  tags: string[] | null;
  reference_link: string | null;
  is_active: TBitValue;
  video_url: string | null;
  image_url: string | null;
  pdf_url: string | null;
}

// ----------------------------start help category ---------------------------

export const GET_ALL_HELP_CATEGORY = (
  pagination: IPagination,
  search: string
) =>
  serviceMaker(
    API_ENDPOINTS.get_all_help_category.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search ? `&search=${encodeURIComponent(search)}` : ""
      }`,
    API_ENDPOINTS.get_all_help_category.method
  );

export const ACTIVE_INACTIVE_HELP_CATEGORY = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_help_category.url + `/${id}`,
    API_ENDPOINTS.active_inactive_help_category.method,
    activeInactiveValue
  );
};

export const DELETE_HELP_CATEGORY = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_help_category.url + `/${id}`,
    API_ENDPOINTS.delete_help_category.method
  );
};

export const CREATE_HELP_CATEGORY = (payload: IHelpCategoryPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_help_category.url,
    API_ENDPOINTS.create_help_category.method,
    payload
  );
};

export const UPDATE_HELP_CATEGORY = (
  payload: IHelpCategoryPayload,
  id: string
) => {
  return serviceMaker(
    API_ENDPOINTS.update_help_category.url + `/${id}`,
    API_ENDPOINTS.update_help_category.method,
    payload
  );
};

export const GET_HELP_CATEGORY_BY_ID = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_help_category.url + `/${id}`,

    API_ENDPOINTS.get_all_help_category.method
  );

// ---------------------------- end help category ---------------------------

// ----------------------------start help topics---------------------------

export const GET_ALL_HELP_TOPICS = (
  pagination: IPagination,
  search: string,
  helpCategoryId?: string
) => {
  const searchHelpCategory = helpCategoryId
    ? `&help_category_id=${helpCategoryId}`
    : "";
  return serviceMaker(
    API_ENDPOINTS.get_all_help_topics.url +
      `?perPageRows=${pagination.perPageRows}&currentPage=${
        pagination.currentPage
      }&sortBy=${pagination.sortBy}&orderBy=${pagination.orderBy}${
        search.length > 0 ? `&search=${encodeURIComponent(search)}` : ""
      }${searchHelpCategory}`,
    API_ENDPOINTS.get_all_help_topics.method
  );
};

export const ACTIVE_INACTIVE_HELP_TOPICS = async (
  id: string,
  activeInactiveValue: IActiveInactive
) => {
  return serviceMaker(
    API_ENDPOINTS.active_inactive_help_topics.url + `/${id}`,
    API_ENDPOINTS.active_inactive_help_topics.method,
    activeInactiveValue
  );
};

export const DELETE_HELP_TOPICS = (id: string) => {
  return serviceMaker(
    API_ENDPOINTS.delete_help_topics.url + `/${id}`,
    API_ENDPOINTS.delete_help_topics.method
  );
};

export const CREATE_HELP_TOPIC = (payload: IHelpTopicFormPayload) => {
  return serviceMaker(
    API_ENDPOINTS.create_help_topic.url,
    API_ENDPOINTS.create_help_topic.method,
    payload
  );
};

export const UPDATE_HELP_TOPIC = (
  payload: IHelpTopicFormPayload,
  id: string
) => {
  return serviceMaker(
    API_ENDPOINTS.update_help_topic.url + `/${id}`,
    API_ENDPOINTS.update_help_topic.method,
    payload
  );
};

export const GET_HELP_TOPIC_BY_ID = (id: string) =>
  serviceMaker(
    API_ENDPOINTS.get_all_help_topics.url + `/${id}`,
    API_ENDPOINTS.get_all_help_topics.method
  );
// ---------------------------- end help topics ---------------------------
